export interface UsageData {
    period: string;
    count: number;
    displayLabel: string;
  }
  
  export interface WorkflowSummary {
    period: string;
    count: number;
  }
  
  export interface RoundStatuses {
    COMPLETED: number;
    FAILED: number;
    not_started: number;
    RUNNING: number;
  }
  
  export interface RoundLibraryLists {
    COMPLETED: string[];
    FAILED: string[];
    not_started: string[];
    RUNNING: string[];
  }
  
  export interface ToolConfig {
    id: "biomarker" | "ppi" | "drug" | "kinase" | "toxicity" | "fatetox" | "mdtr" | "animal";
    icon: string;
    tagBg: string;
    tagColor: string;
    accentColor: string;
    required: boolean[];
    sliceKey: "biomarker" | "ppi" | "kinase" | "drug" | "toxicity" | "fatetox" | "mdtr" | "animal";
  }

  export interface ToolGroupConfig {
    id: "biomarkerDiscovery" | "drugDesign" | "drugResponse" | "drugToxicity";
    icon: string;
    tagBg: string;
    tagColor: string;
    accentColor: string;
    toolIds: ToolConfig["id"][];
  }

  export const TOOLS: ToolConfig[] = [
    {
      id: "biomarker",
      icon: "🧫",
      tagBg: "rgba(73,104,162,0.10)",
      tagColor: "#4968A2",
      accentColor: "#4968A2",
      required: [true, true, true],
      sliceKey: "biomarker",
    },
    {
      id: "ppi",
      icon: "🔬",
      tagBg: "rgba(58,82,130,0.10)",
      tagColor: "#3a5282",
      accentColor: "#3a5282",
      required: [false, true, false, true, true, true],
      sliceKey: "ppi",
    },
    {
      id: "drug",
      icon: "💊",
      tagBg: "rgba(16,185,129,0.10)",
      tagColor: "#059669",
      accentColor: "#10b981",
      required: [true, true],
      sliceKey: "drug",
    },
    {
      id: "kinase",
      icon: "🧬",
      tagBg: "rgba(245,158,11,0.10)",
      tagColor: "#d97706",
      accentColor: "#f59e0b",
      required: [false, true, true, false, true],
      sliceKey: "kinase",
    },
    {
      id: "toxicity",
      icon: "⚗️",
      tagBg: "rgba(192,0,0,0.08)",
      tagColor: "#c00000",
      accentColor: "#C00000",
      required: [true, false],
      sliceKey: "toxicity",
    },
    {
      id: "mdtr",
      icon: "🧪",
      tagBg: "rgba(73,104,162,0.10)",
      tagColor: "#4968A2",
      accentColor: "#4968A2",
      required: [true, true, true],
      sliceKey: "mdtr",
    },
    {
      id: "fatetox",
      icon: "⚗️",
      tagBg: "rgba(16,185,129,0.10)",
      tagColor: "#059669",
      accentColor: "#059669",
      required: [true],
      sliceKey: "fatetox",
    },
    {
      id: "animal",
      icon: "🐾",
      tagBg: "rgba(245,158,11,0.10)",
      tagColor: "#d97706",
      accentColor: "#f59e0b",
      required: [],
      sliceKey: "animal",
    },
  ];

  export const TOOL_GROUPS: ToolGroupConfig[] = [
    {
      id: "biomarkerDiscovery",
      icon: "🧫",
      tagBg: "rgba(73,104,162,0.10)",
      tagColor: "#4968A2",
      accentColor: "#4968A2",
      toolIds: ["biomarker"],
    },
    {
      id: "drugDesign",
      icon: "🔬",
      tagBg: "rgba(58,82,130,0.10)",
      tagColor: "#3a5282",
      accentColor: "#3a5282",
      toolIds: ["ppi", "kinase"],
    },
    {
      id: "drugResponse",
      icon: "💊",
      tagBg: "rgba(16,185,129,0.10)",
      tagColor: "#059669",
      accentColor: "#10b981",
      toolIds: ["drug"],
    },
    {
      id: "drugToxicity",
      icon: "⚗️",
      tagBg: "rgba(192,0,0,0.08)",
      tagColor: "#c00000",
      accentColor: "#C00000",
      toolIds: ["fatetox", "mdtr", "animal"],
    },
  ];
  
  export const muiInput = {
    "& .MuiOutlinedInput-root": {
      borderRadius: "12px",
      backgroundColor: "#f8fafc",
      fontSize: "13px",
      "& fieldset": { borderColor: "#e2e8f0" },
      "&:hover fieldset": { borderColor: "#94a3b8" },
      "&.Mui-focused fieldset": { borderColor: "#4968A2", borderWidth: "1.5px" },
    },
    "& .MuiInputLabel-root": { color: "#64748b", fontSize: "13px" },
    "& .MuiInputLabel-root.Mui-focused": { color: "#4968A2" },
  };
  
  export const TOOL_NAME_MAP: Record<ToolConfig["sliceKey"], string> = {
    biomarker: "Biomarker",
    ppi: "PPI Inhibitor",
    kinase: "Kinase Inhibitor",
    drug: "Drug Response",
    toxicity: "Drug Toxicity",
    fatetox: "FateTox",
    mdtr: "MDTR",
    animal: "Animal",
  };
